<template>
    <div>
        <div class="mb-3">
            <b-button
                    @click="onSelectTab('dpd')"
                    variant="danger">
                DPD
            </b-button>
            <b-button
                    style="background-color: yellow;color: #000"
                    @click="onSelectTab('post')"
                    variant="info">
                POST
            </b-button>
            <b-button
                    @click="onSelectTab('reviewed')"
                    variant="primary">
                Zugestellt
            </b-button>
            <b-button
                    @click="onSelectTab('ups')"
                    variant="warning">
                UPS
            </b-button>
            <b-button
                    @click="onSelectTab('gls')"
                    variant="success">
                GLS
            </b-button>
        </div>

        <b-card v-if="orderTransportType.type !== null">
            <p>
                <template v-if="orderTransportType.type === 'dpd'">
                        <span>
                            <img class="mr-4" src="/images/dbd.svg" alt="dpd" width="100">
                        </span>
                </template>
                <template v-else-if="orderTransportType.type === 'post'">
                        <span>
                            <img class="mr-4" src="/images/post.svg" alt="post" width="100">
                        </span>
                </template>
                <template
                        v-else-if="orderTransportType.type === 'reviewed' || orderTransportType.type === 'box' || orderTransportType.type === 'reviewedMain'">
                    <b-button
                            @click="onClickBoxButton('box')"
                            variant="primary" class="mr-5">Briefkasten
                    </b-button>
                    <b-button
                            @click="onClickBoxButton('reviewed')"
                            variant="primary" class="mr-5">Nachbar
                    </b-button>
                    <b-button
                            :disabled="order.order_status === 'reviewed'"
                            @click="updateStatusReviewed('reviewedMain')"
                            :variant="(order.order_status === 'reviewed' ? 'success' : 'primary')" class="mr-5">Hausbewohner
                    </b-button>
                </template>
            </p>

            <template v-if="orderTransportType.type === 'ups' || orderTransportType.type === 'gls'">
                <h4 style="text-transform: uppercase" class="font-weight-bold">{{orderTransportType.type}}</h4>
            </template>

            <b-row>
                <template
                        v-if="orderTransportType.type === 'post' || orderTransportType.type === 'dpd' || orderTransportType.type === 'reviewed' || orderTransportType.type === 'box' || orderTransportType.type === 'ups' || orderTransportType.type === 'gls'">


                    <b-col cols="12" md="4">
                        <b-input v-model="orderTransportType.orderNumber"
                                 :placeholder="getPlaceHolder"></b-input>
                    </b-col>
                    <b-col cols="12" md="4">
                        <date-picker
                                format="YYYY-MM-DD"
                                display-format="YYYY-MM-DD"
                                popover auto-submit locale="en" v-model="orderTransportType.date"></date-picker>
                    </b-col>

                    <b-col cols="12" md="4">
                        <b-button
                                v-if="isEditOrderLog"
                                @click="updateLog"
                                class="mb-5 mb-md-0" variant="success">
                            {{$t('save')}}
                        </b-button>
                        <b-button
                                v-else
                                @click="updateStatus('orderLog')"
                                class="mb-5 mb-md-0" variant="success">
                            Senden
                        </b-button>
                    </b-col>

                </template>

            </b-row>


        </b-card>

        <div class="table-responsive">
            <table class="table">
                <thead>
                <tr>
                    <th>description</th>
                    <th>type</th>
                    <th>date</th>
                    <th></th>
                </tr>
                </thead>
                <tbody v-if="orderLogs.length > 0">
                <tr v-for="(log,index) in getLogs" :key="index">
                    <td v-html="log.description"></td>
                    <td>{{log.type}}</td>
                    <td>{{log.created_at}}</td>
                    <td>
                        <template v-if="log.type === 'Post' || log.type === 'DPD' || log.type === 'Zugestellt'">
                            <b-button
                                    @click="editOrderLog(log)"
                                    variant="info">edit
                            </b-button>

                        </template>
                        <b-button
                                @click="deleteOrderLog(log.id)"
                                variant="danger">
                            delete
                        </b-button>

                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import Http from '../../../Services/HttpService/HttpService'
    import Notification from '../../../Services/Notification/Nottification'
    import {EventBus} from "../../../Services/Eventbus/event-bus";

    export default {
        name: "postAndDpd",
        props: {
            orderLogs: {
                type: Array,
                default: null
            },
            order: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                isEditOrderLog: false,
                orderTransportType: {
                    type: null,
                    orderNumber: null,
                    logId: 0,
                    date: ''
                }
            }
        },
        methods: {
            onSelectTab(myType) {
                this.orderTransportType.type = myType;
                this.orderTransportType.logId = 0;
                this.isEditOrderLog = false;
            },
            onClickBoxButton(myType) {
                this.orderTransportType.type = myType;
            },
            updateStatus(myType) {
                this.$Progress.start();
                Http.post(Http.apiurlV2() + 'order/update/' + this.$route.params.orderid, {
                    type: myType,
                    logType: this.orderTransportType.type,
                    orderNumber: this.orderTransportType.orderNumber,
                    date: this.orderTransportType.date,
                })
                    .then(response => {
                        if (response.data.status_code === Http.ok()) {
                            this.$Progress.finish();
                            this.resetOrderLogForm();
                            Notification.success(response.data.message);
                            EventBus.$emit('updateLog', 'yes')
                        } else {
                            Notification.error(response.data.message);
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            updateStatusReviewed(myType) {
                this.$Progress.start();
                Http.post(Http.apiurlV2() + 'order/update/' + this.$route.params.orderid, {
                    type: 'orderLog',
                    logType: myType,
                    orderNumber: null,
                    date: null,
                })
                    .then(response => {
                        if (response.data.status_code === Http.ok()) {
                            this.$Progress.finish();
                            Notification.success(response.data.message);
                            EventBus.$emit('updateLog', 'yes');
                        } else {
                            Notification.error(response.data.message);
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            editOrderLog(myItem) {
                this.isEditOrderLog = true;
                this.orderTransportType.logId = myItem.id;
                this.orderTransportType.type = myItem.type;
                this.orderTransportType.orderNumber = myItem.tracking_code;
                this.orderTransportType.date = myItem.created_at;
            },
            resetOrderLogForm() {
                this.orderTransportType.logId = 0;
                this.orderTransportType.orderNumber = null;
                this.orderTransportType.date = null;
            },
            deleteOrderLog(myId) {
                if (confirm(this.$t('alertText'))) {
                    this.$Progress.start();
                    Http.get(Http.apiurlV2() + 'order/delete/log/' + myId)
                        .then(response => {
                            this.$Progress.finish();
                            if (response.data.status_code === Http.ok()) {
                                this.isEditOrderLog = false;
                                EventBus.$emit('updateLog', 'yes');
                                Notification.success(response.data.message)
                            } else {
                                Notification.error(response.data.message)
                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }
            },
            updateLog() {
                this.$Progress.start();
                Http.post(Http.apiurlV2() + 'order/update/log/' + this.orderTransportType.logId, {
                    type: this.orderTransportType.type,
                    orderNumber: this.orderTransportType.orderNumber,
                    date: this.orderTransportType.date,
                })
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            this.isEditOrderLog = false;
                            EventBus.$emit('updateLog', 'yes');
                            this.resetOrderLogForm();
                            Notification.success(response.data.message)

                        } else {
                            Notification.error(response.data.message)

                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
        },
        computed: {
            getPlaceHolder() {
                if (this.orderTransportType.type === 'reviewed') {
                    return "Türnummer";
                } else if (this.orderTransportType.type === 'box') {
                    return "Briefkastennummer";
                } else {
                    return "Trackingcode";
                }
            },
            getLogs() {
                let transportType = (this.orderTransportType.type === null ? 'dpd' : this.orderTransportType.type);

                return this.orderLogs.filter(item => {
                    return item.type_value.match(transportType);
                })


            }
        }

    }
</script>

<style scoped>

</style>